// extracted by mini-css-extract-plugin
export const nav = "navigation-module--nav--86f2c";
export const compact = "navigation-module--compact--2bXuU";